// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 957 ? "routes" : chunkId) + "." + {"121":"cf19a875","957":"dffc54c9"}[chunkId] + ".css";
};